import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { INPUT_TYPE, STRING } from '../types';
import { FORM_STYLE_CONFIG } from '../d-form/style.config';

@Component({
  selector: 'app-d-form-input',
  templateUrl: './d-form-input.component.html',
  styleUrls: ['./d-form-input.component.css']
})
export class DFormInputComponent implements OnInit {
	@Input() formElements: any;
	@Input() options = {
		withElementPadding: false
	};
	@Input() formGroup: FormGroup;
	value: any = {};
	elementClass: string;
	@Output() change = new EventEmitter();
	INPUT_TYPE = INPUT_TYPE;
	FORM_STYLE_CONFIG = FORM_STYLE_CONFIG;
	constructor() { }

	private _formatView() {
		if (this.options) {
			if (this.options.withElementPadding) {
				this.elementClass = FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.condition.withElementPadding;
			}
		}
	}

	ngOnInit() {
		this._formatView();
  	}

	private _runEvent(formElement, eventName) {
		const value = this.value[formElement.name];
		if (!formElement || !formElement[eventName]) {
			return;
		}
		if (!(typeof formElement[eventName] === STRING.FUNCTION)) {
			return console.warn(
				`${eventName} of element <<${
					formElement.name
				}>> is not a function !`
			);
		}
		return value;
	}

	private _runOnChangeElement(formElement) {
		const value = this._runEvent(formElement, STRING.ON_CHANGE);
		if (value === undefined) {
			return;
		}
		formElement.onChange.bind(this)(value);

	}

	private _runOnBlurElement(formElement) {
		const value = this._runEvent(formElement, STRING.ON_BLUR);
		if (value === undefined) {
			return;
		}
		formElement.onBlur.bind(this)(value);
	}

	onChange(event) {
		if (event.name) {
			this.value[event.name] = event.value;
			const formElement = this.formElements.find(
				element => element.name === event.name
			);
			if (formElement) {
				this._runOnChangeElement(formElement);
			}
			this.change.emit();
		}
	}

	onBlur(event) {
		if (event.name) {
			const formElement = this.formElements.find(
				element => element.name === event.name
			);
			if (formElement) {
				this._runOnBlurElement(formElement);
			}
		}
	}

}
